export default "__VITE_ASSET__BGSOeRps__"